import AdultPHQ4 from '../ScreeningImplementations/AdultPHQ4/Form/AdultPHQ4';
import AdultUCLA3 from '../ScreeningImplementations/AdultUCLA3/Form/AdultUCLA3';
import YouthNeeds from '../ScreeningImplementations/YouthNeeds/Form/YouthNeeds';
import YouthPHQ2 from '../ScreeningImplementations/YouthPHQ2/Form/YouthPHQ2';
import YouthUCLA3 from '../ScreeningImplementations/YouthUCLA3/Form/YouthUCLA3';
import AdultPRAPARE from '../ScreeningImplementations/AdultPRAPARE/Form/AdultPRAPARE';
import AdultEPPRAPARE from '../ScreeningImplementations/AdultEPPRAPARE/Form/AdultEPPRAPARE';
import AdultWellBeing from '../ScreeningImplementations/AdultWellBeing/Form/AdultWellBeing';
import AdultNeeds from '../ScreeningImplementations/AdultNeeds/Form/AdultNeeds';
import CAHPSPyxPlus from '../ScreeningImplementations/CAHPSPyxPlus/Form/CAHPSPyxPlus';
import EPDSScreening from '../ScreeningImplementations/EPDS/Form/EPDSScreening';
import HOSScreening from '../ScreeningImplementations/HOS/Form/HOSScreening';
import { Screenings } from '../enumerations/enums';

export const Forms = {
  [Screenings.YOUTH_UCLA3]: YouthUCLA3,
  [Screenings.YOUTH_PHQ2]: YouthPHQ2,
  [Screenings.YOUTH_NEEDS]: YouthNeeds,
  [Screenings.ADULT_UCLA3]: AdultUCLA3,
  [Screenings.ADULT_PHQ4]: AdultPHQ4,
  [Screenings.ADULT_NEEDS]: AdultNeeds,
  [Screenings.ADULT_PRAPARE]: AdultPRAPARE,
  [Screenings.ADULT_EP_PRAPARE]: AdultEPPRAPARE,
  [Screenings.ADULT_WELLBEING]: AdultWellBeing,
  [Screenings.CAHPS_PYXPLUS]: CAHPSPyxPlus,
  [Screenings.EPDS]: EPDSScreening,
  [Screenings.HOS]: HOSScreening,
};
